export const getISODate = (date: string | null | undefined): string | null => {
  if (date === null || date === undefined) return null;

  return new Date(date).toISOString();
};

// later we can add other formats here
